<template>
  <mdb-modal centered elegant scrollable size="lg" :show="mostrarModal" @close="cerrar">
    <mdb-modal-header class="pb-0">
      <mdb-modal-title>
        <font-awesome-icon icon="clipboard-list" class="mr-2 text-muted" />
        Solicitar revisión de factura
      </mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <div v-if="suc && Object.keys(suc).length">
        <div class="encabezado-detalles p-3 mb-3">
          <p class="font-weight-bold mb-1">{{ suc.nom_emp }} - {{ suc.nom_suc }}</p>
          <p class="mb-0 text-muted small">
            <font-awesome-icon icon="map-marker-alt" class="mr-1" />
            {{ suc.dir_suc }}
          </p>
        </div>

        <div v-if="factura" class="card-bordered p-3 mb-3">
          <p class="font-weight-bold mb-2">
            <font-awesome-icon icon="file-invoice" class="mr-2 text-muted" />
            Factura asociada
          </p>
          <div class="row">
            <div class="col-12 col-sm-6">
              <span class="small-block">Número</span>
              <span>#{{ factura.num_fac }}</span>
            </div>
            <div class="col-12 col-sm-6">
              <span class="small-block">Fecha</span>
              <span>{{ factura.fec_fac }}</span>
            </div>
            <div class="col-12 col-sm-6 mt-2">
              <span class="small-block">Fecha de vencimiento</span>
              <span :class="colorVencimiento">{{ factura.fec_ven_fac }}</span>
            </div>
            <div class="col-12 col-sm-6 mt-2">
              <span class="small-block">Monto</span>
              <span class="font-weight-bold">{{ parseFloat(factura.mon_fac).toFixed(2) }} Bs.</span>
            </div>
          </div>
          <div v-if="diasRestantes !== null" class="mt-2" :class="alertaVencimiento">
            <font-awesome-icon :icon="diasRestantes < 0 ? 'exclamation-circle' : 'info-circle'" class="mr-1" />
            <span v-if="diasRestantes < 0">Factura vencida hace {{ Math.abs(diasRestantes) }} días</span>
            <span v-else-if="diasRestantes <= 7">Factura vence en {{ diasRestantes }} días</span>
            <span v-else>Factura vigente ({{ diasRestantes }} días restantes)</span>
          </div>
        </div>
        <div v-if="suc.fec_redesu" class="card-bordered p-3 mb-3">
          <p class="font-weight-bold mb-2">
            <font-awesome-icon icon="calendar-check" class="mr-2 text-muted" />
            Recepción
          </p>
          <span class="texto-exitoso font-weight-bold">{{ suc.fec_redesu }}</span>
        </div>

        <div class="form-group">
          <label class="small-block">Motivo de la solicitud</label>
          <textarea v-model="solicitud" class="form-control" rows="4" placeholder="Describa el motivo por el cual solicita la revisión de la fecha de vencimiento..."></textarea>
        </div>
      </div>
    </mdb-modal-body>
    <mdb-modal-footer class="justify-content-around">
      <mdb-btn flat dark-waves icon="times" @click="cerrar">Cancelar</mdb-btn>
      <mdb-btn color="primario" icon="paper-plane" :disabled="!solicitud.trim()" @click="enviar">
        Enviar solicitud
      </mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
} from 'mdbvue';

export default {
  name: 'SolicitarRevision',
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
  },
  props: {
    mostrarModal: {
      type: Boolean,
      required: true,
    },
    suc: {
      type: Object,
      default: () => ({}),
    },
    factura: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      solicitud: '',
    };
  },
  computed: {
    diasRestantes() {
      if (!this.factura || !this.factura.fec_ven_fac) return null;
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      const venc = new Date(this.factura.fec_ven_fac);
      venc.setHours(0, 0, 0, 0);
      const diff = Math.ceil((venc - hoy) / (1000 * 60 * 60 * 24));
      return diff;
    },
    colorVencimiento() {
      if (this.diasRestantes === null) return '';
      if (this.diasRestantes < 0) return 'texto-error font-weight-bold';
      if (this.diasRestantes <= 7) return 'texto-secundario font-weight-bold';
      return 'texto-exitoso';
    },
    alertaVencimiento() {
      if (this.diasRestantes === null) return '';
      if (this.diasRestantes < 0) return 'alerta error p-2 rounded';
      if (this.diasRestantes <= 7) return 'alerta advertencia p-2 rounded';
      return 'alerta informativa p-2 rounded';
    },
  },
  watch: {
    mostrarModal(val) {
      if (val) {
        this.solicitud = '';
      }
    },
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    enviar() {
      if (!this.solicitud.trim()) return;
      this.$emit('enviar', {solicitud: this.solicitud.trim()});
    },
  },
};
</script>

<style lang="scss" scoped>
.small-block {
  display: block;
  font-size: 80%;
  color: #6c757d;
  text-transform: uppercase;
}
</style>
